import { AddCircle, CheckCircle, Person, Cancel } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import { JSX } from "react";
import { WaitingRoomStatus } from "src/api/types";

interface Props {
  status: WaitingRoomStatus;
}

const iconMap: Record<WaitingRoomStatus, JSX.Element> = {
  ADDED: <AddCircle sx={{ color: "#3498db" }} fontSize="large" />,
  ASSIGNED: <Person sx={{ color: "#f39c12" }} fontSize="large" />,
  COMPLETED: <CheckCircle sx={{ color: "#27ae60" }} fontSize="large" />,
  CANCELED: <Cancel sx={{ color: "#e74c3c" }} fontSize="large" />,
};

const RoomStatus = ({ status }: Props) => {
  return (
    <Tooltip
      arrow
      title={<Typography>{status}</Typography>}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
    >
      {iconMap[status]}
    </Tooltip>
  );
};

export default RoomStatus;
